import React from 'react';
import styles from './BrandServices.module.css'; // Updated import for CSS Module

const BrandServices = () => {
  return (
    <section className={styles['brand-services-container']}> {/* Use styles object */}
      <h2 className={styles['main-heading']}> {/* Use styles object */}
        Brand Services We Offer
      </h2>

      <div className={styles['content-wrapper']}> {/* Use styles object */}
        {/* --- Left Column: Brand Strategy --- */}
        <div className={`${styles['service-column']} ${styles['strategy-column']}`}> {/* Combine classes */}
          <h3 className={styles['service-title']}>Brand Strategy</h3> {/* Use styles object */}
          <ul>
            <li>Brand Purpose</li>
            <li>Brand Vision</li>
            <li>Brand Values</li>
            <li>Target Audience</li>
            <li>Market Analysis</li>
            <li>Brand Story</li>
            <li>Brand Personality</li>
            <li>Brand Voice</li>
            <li>Brand Positioning</li>
            <li>Brand Naming</li>
          </ul>
        </div>

        {/* --- Center Area: Image and Design/Content --- */}
        <div className={styles['center-area']}> {/* Use styles object */}
           <div className={styles['image-container']}> {/* Use styles object */}
             <img
               src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1745860557/fkg9yjetnslvmeb1j3wp.png"
               alt="Creative Brand Representation"
               className={styles['center-image']} // Use styles object
            />
           </div>
           {/* --- Bottom (Center on Desktop): Brand Design & Content --- */}
           <div className={`${styles['service-column']} ${styles['design-column']}`}> {/* Combine classes */}
             <h3 className={styles['service-title']}>Brand Design & Content</h3> {/* Use styles object */}
             <ul>
               <li>Brand Logo Design</li>
               <li>Brand Identity</li>
               <li>Brand Guidelines</li>
               <li>Stationery Design</li>
               <li>Corporate Identity</li>
               <li>Premium Business Card</li>
               <li>Corporate Profile</li>
               <li>Catalogue Design</li>
             </ul>
           </div>
        </div>

        {/* --- Right Column: Brand Marketing --- */}
        <div className={`${styles['service-column']} ${styles['marketing-column']}`}> {/* Combine classes */}
          <h3 className={styles['service-title']}>Brand Marketing</h3> {/* Use styles object */}
          <ul>
            <li>Website Design</li>
            <li>Space Branding</li>
            <li>Front and Backend Development</li>
            <li>Lead Generation</li>
            <li>Digital marketing management</li>
            <li>Social media Marketing</li>
            <li>Tv Production</li>
            <li>Radio Production</li>
            <li>Print Production</li>
            <li>Video Scripting and Production</li>
            <li>Social Marketing Campaigns</li>
            <li>Content Marketing</li>
            <li>Photography</li>
            <li>Out Door Media Marketing</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default BrandServices;